import React from 'react';

import './icon-csv-file.css';

export const IconCSVFile = (): JSX.Element => <img className="icon-csv-file inline" alt=".csv file icon" />;
